/**
 * Per-extension colored badge used as the avatar fallback when a
 * document has no rendered thumbnail (e.g. video uploads, conversion
 * failures, or the v1 case where presigned thumbnail URLs aren't
 * embedded in list responses yet).
 *
 * Mirrors the palette used in `components/DocumentsTableCN` so the
 * legacy and new libraries look consistent side-by-side.
 */
const DOCUMENT_ICONS: Record<string, { color: string; label: string }> = {
	pdf: { color: '#ef4444', label: 'PDF' },
	doc: { color: '#2563eb', label: 'DOC' },
	docx: { color: '#2563eb', label: 'DOCX' },
	xls: { color: '#059669', label: 'XLS' },
	xlsx: { color: '#059669', label: 'XLSX' },
	ppt: { color: '#d97706', label: 'PPT' },
	pptx: { color: '#d97706', label: 'PPTX' },
	csv: { color: '#10b981', label: 'CSV' },
	txt: { color: '#6b7280', label: 'TXT' },
	jpg: { color: '#a855f7', label: 'JPG' },
	jpeg: { color: '#a855f7', label: 'JPG' },
	png: { color: '#a855f7', label: 'PNG' },
	gif: { color: '#a855f7', label: 'GIF' },
	mp4: { color: '#ec4899', label: 'MP4' },
	mov: { color: '#ec4899', label: 'MOV' },
	default: { color: '#4b5563', label: 'DOC' },
}

export const getDocumentIcon = (filename: string | null | undefined) => {
	if (!filename) return DOCUMENT_ICONS.default
	const extension = filename.split('.').pop()?.toLowerCase() || ''
	return DOCUMENT_ICONS[extension] || DOCUMENT_ICONS.default
}
